import { LogOut, Bell } from 'lucide-react'
import { useLogout } from '../../api/auth'
import { useAuthStore } from '../../store/authStore'
import { Button } from '../ui/Button'

interface HeaderProps {
  title?: string
}

export default function Header({ title }: HeaderProps) {
  const user = useAuthStore((state) => state.user)
  const logoutMutation = useLogout()

  const handleLogout = () => {
    logoutMutation.mutate()
  }

  return (
    <header className="sticky top-0 z-40 h-16 glass-header flex items-center justify-between px-6">
      <div className="flex items-center gap-4">
        {title && (
          <h1 className="text-xl font-bold text-white tracking-tight">
            {title}
          </h1>
        )}
      </div>

      <div className="flex items-center gap-4">
        {/* System Status */}
        <div className="flex items-center gap-2.5 text-xs font-medium tracking-widest uppercase text-text-secondary">
          <span className="status-dot" />
          <span>Система работает</span>
        </div>

        {/* Divider */}
        <div className="w-px h-8 bg-white/10" />

        {/* Notifications */}
        <button className="relative p-2 rounded-lg text-text-secondary hover:text-white hover:bg-white/5 transition-colors">
          <Bell className="w-5 h-5" />
        </button>

        {/* User menu */}
        <div className="flex items-center gap-3 pl-3 border-l border-white/10">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-white/20 to-white/5 flex items-center justify-center text-sm font-semibold text-white border border-white/10">
            {user?.username?.charAt(0).toUpperCase() || 'U'}
          </div>
          <span className="text-sm font-medium text-white hidden sm:inline">
            {user?.username}
          </span>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleLogout}
            className="ml-2"
            title="Выйти"
          >
            <LogOut className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </header>
  )
}
